<form [formGroup]="form" (ngSubmit)="accept()" novalidate>
    <div class="modal-header">
        <h4 class="modal-title">Unir Llave Privada</h4>
        <button type="button" class="close" aria-label="Close" (click)="dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="card-body table-responsive table-hover p-0"
                style="height: auto; max-height: 600px; padding-bottom: 10px !important;">
                <table class="table table-bordered table-head-fixed">
                    <thead>
                        <tr>
                            <th scope="col">Orden de Llave</th>
                            <th scope="col">Fragmento</th>
                        </tr>
                    </thead>
                    <ng-container formArrayName="items">
                        <tbody *ngFor="let item of itemValues.controls; let i=index" [formGroupName]="i">
                            <tr>
                                <td>Fragmento {{item.value.posicion}} de {{form.value.fragmentos}}</td>
                                <td>
                                    <input type="text" class="form-control" id="fragmento" formControlName="fragmento">
                                </td>
                            </tr>
                        </tbody>
                    </ng-container>
                </table>
            </div>
        </div>

        <div class="modal-footer full-width col-md-12">
            <div class="col-md-12 text-center">
                <button type="button" class="btn btn-danger btn-fidelis col-md-4" (click)="dismiss()">
                    <i class="fa fa-times-circle"></i>
                    Cancelar
                </button>
                <button type="submit" class="btn btn-success btn-fidelis col-md-4">
                    <i class="fa fa-check-circle"></i>
                    Unir Llave Privada
                </button>
            </div>
        </div>

    </div>
</form>